<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/customers",
		    "name": "Customers"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Customers</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<!-- Start Introduction -->
<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-8 col-md-8 col-xl-8">
                <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
                    <h1 id="bnr-heading">{{heading}}</h1>
                    <h2 id="bnr-subheading">{{subheading}}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                    <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- End Introduction -->

<!-- <div class="container mt-50 text-center">
      <h3>Our customers trust innovative products to provide mobile and app security </h3>
</div> -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6  ">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/customers/image-2.webp" class="og_image_url" alt="Providing Innovative Solution">
                    </div>
                </div>
            </div>
            <div class="col-lg-6  ">
                <div class="agency-benefits">
                    <div class="content">
                        <div>
                            <h2>Delivering the value</h2>
                        </div>
                        <p>Our promise to work, innovativeness & zeal to deliver excellence to secure our customer
                            mobile device. Our happy and cyber secure customers are the reason to our success stories.
                        </p>
                        <p>Breaking the conventional walls and providing innovative solution to customers is basis of
                            our character.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Agency Benefits Area -->


<!-- Start Our Customers -->
<div class="section-agency-benefit">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12  ">
                <div class="section-title text-center">
                    <h2>Our Customers</h2>
                </div>
            </div>
        </div>
        <!-- <div class="row align-items-center">

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/bselogo.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/cholams.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb mt-3">
                    <div class="thumb">
                        <img src="assets/images/home/ageasfederal.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/iiflsecurities.png" alt="Customer Logo">
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre> -->

        <!-- <div class="row align-items-center">

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/pramerica.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/iccl.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/iiflhome.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/5paisa.png" alt="Customer Logo">
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre> -->

        <!-- <div class="row align-items-center">
            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/iiflfinance.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/indiainx.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb mt-2">
                    <div class="thumb">
                        <img src="assets/images/home/indiaicc.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/suryoday_logo.webp" alt="Customer Logo">
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre> -->

        <!-- <div class="row justify-content-center align-items-center">
            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/fusion_logo.webp" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/kinara.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/edprime.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/mindgate.png" alt="Customer Logo">
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre> -->

        <!-- <div class="row justify-content-center align-items-center">

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/yes_bank.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/RBL_Bank.png" alt="Customer Logo">
                    </div>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="agency-thumb">
                    <div class="thumb">
                        <img src="assets/images/home/fincare.png" alt="Customer Logo">
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre>
        <pre></pre> -->


        <ul class="row mt-30 prestigiouscustul">
    
            <li><img class="img-fluid" src="assets/images/new/bsemain.webp" alt="BSE Experience The New">
            </li>
            <li><img class="img-fluid" src="assets/images/new/RBL_Bank.webp" alt="RBL Bank"></li>
            <li><img class="img-fluid" src="assets/images/new/Yes_Bank_logo.webp" alt="YES Bank"></li>
            <li><img class="img-fluid" src="assets/images/new/fincare.webp" alt="Fincare"></li>
            <li><img class="img-fluid" src="assets/images/new/Chola-MS.webp" alt="Chola MS"></li>
            <li><img class="img-fluid" src="assets/images/new/iifl_home.webp" alt="IIFL Home Loan"></li>
            <li><img class="img-fluid" src="assets/images/new/iifl_security.webp" alt="IIFL Securities">
            </li>
            <li><img class="img-fluid" src="assets/images/new/suryoday_logo.webp" alt="SURYODAY"></li>
            <li><img class="img-fluid" src="assets/images/new/fusion_logo.webp" alt="FUSION"></li>
            <li><img class="img-fluid" src="assets/images/new/pharmatica.webp" alt="PRAMERICA"></li>
            <li><img class="img-fluid" src="assets/images/new/ageas_fedral.webp" alt="ageasFEDERAL"></li>
            <li><img class="img-fluid" src="assets/images/new/equitas_logo.webp" alt="Equitas"></li>
            <li><img class="img-fluid" src="assets/images/new/iifl_finance.webp" alt="IIFL Finance"></li>
            <li><img class="img-fluid" src="assets/images/new/india_icc.webp" alt="INDIA ICC"></li>
            <li><img class="img-fluid" src="assets/images/new/india_inx.webp" alt="INDIA INX"></li>
            <li><img class="img-fluid" src="assets/images/new/kinara.webp" alt="KINARA CAPITAL"></li>
            <li><img class="img-fluid" src="assets/images/new/midgate.webp" alt="MINDGATE"></li>
            <li><img class="img-fluid" src="assets/images/new/iccl.webp" alt="ICCL"></li>
            <li><img class="img-fluid" src="assets/images/new/5paisa.webp" alt="5Paisa"></li>
            <li><img class="img-fluid" src="assets/images/new/ed_prime.webp" alt="ED PRIME"></li>

        </ul>


    </div>
</div>
<!-- End Our Customers -->